import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Label, Input } from './Input';
import { colors } from '../utils';

const Form = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const Col = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;

  &:last-child {
    justify-content: flex-end;
  }
`;

const ForgotPasswordLink = styled.a`
  color: ${colors.g04};
  display: block;
  flex: 1;
  font-size: 12px;
  line-height: normal;
  margin: auto;
  margin-bottom: 8px;
  text-align: right;
  text-decoration: underline;
`;

const InputPassword = props => (
  <Form>
    <Row>
      <Col>{props.label && <Label>{props.label}</Label>}</Col>

      <Col>
        <ForgotPasswordLink
          href="https://neevo.definedcrowd.com/en-us/account/forgotpassword/"
          target="_blank"
          tabIndex="-1"
        >
          Forgot password?
        </ForgotPasswordLink>
      </Col>
    </Row>

    <Input
      {...props}
      data-aat={`${props['data-aat']}-input`}
      placeholder="Password"
      type="password"
    />
  </Form>
);

InputPassword.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  'data-aat': PropTypes.string
};

InputPassword.defaultProps = {
  label: '',
  'data-aat': ''
};

export { InputPassword };
